<template>
  <input
    type="file"
    ref="files"
    multiple
    :accept="accept.join(',')"
    @change="onChangeFile"
  />
</template>

<script>
export default {
  props: {
    accept: {
      type: Array,
      default: () => ['.doc', '.docx', '.txt', '.hwp', '.pdf'],
    },
  },
  methods: {
    click() {
      this.$refs.files?.click()
    },
    onChangeFile() {
      const files = Array.from(this.$refs.files?.files)
      this.$emit('input', files)
      this.$emit('change', files)
    },
  },
}
</script>

<style lang="scss" scoped>
input[type='file'] {
  display: none;
}
</style>
